import { ChangePasswordForm } from '@/modules/Users/ChangePassword.form';
import { ResetType } from '@/modules/Users/Users.schema';

const ResetPassword = () => <ChangePasswordForm reset_type={ResetType.PASSWORD} />;

export default ResetPassword;
